import React from 'react';
import { Box, Button, Grid, Tooltip, Typography } from '@mui/material';
import { truncateComment } from 'utils/utils';
import UploadIcon from 'assets/images/UploadIcon.svg';
import closeIcon from 'assets/images/CrossBtn.svg'

function CommonMultiFile(props) {
  const multiImage = props?.selectedMultiFiles || props?.selectedMultiFiles?.documentsType

  return (
    <div>
      <Box>
        <Button
          variant="contained"
          component="label"
          className="fileUploader commonBorder"
        >
          <Box className="fileUploadContainer justifyCenter">
            <Box>
              <Typography
                variant="body2"
                component={'h5'}
                className="colorGrey fw400 justifyCenter textCapitalize"
              >
                Upload Multi
                <Typography
                  component={'span'}
                  variant="body2"
                  className=" fw400 "
                >
                  <img
                    src={UploadIcon}
                    className="marginInline10"
                    alt="image"
                  />
                </Typography>
              </Typography>
            </Box>

            <input
              type="file"
              hidden
              accept="image/jpeg, image/png,.pdf,.doc"
              multiple
              onChange={props?.handleFileChange}
            />
          </Box>
        </Button>
      </Box>
      <Box>
      <Typography className="font14">
          {multiImage?.length > 0 && (
            <Grid container>
              {multiImage?.map((file, index) => (
        <Grid item key={index} className='dflex'>
          {index > 0 && ','}
          <Tooltip title={file?.file?.name || file?.name} placement="bottom">
            <Box className='alignItem'>
            <span className={index >0 ? 'ml5': ''}>
              {truncateComment((file?.file?.name || file?.name), 20)}
            </span> 
            <img src={closeIcon} className="width20 cursor" onClick={() => props?.removeFile(index)} />
            </Box>
          </Tooltip>
        </Grid>
      ))}
            </Grid>
          )}
        </Typography>
      </Box>
    </div>
  );
}

export default CommonMultiFile;
